import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { Constants } from '../../../endPoints';

export default function Searchmainselection({ setMainSelection }) {
  const [selections, setSelections] = useState([]);
  const [isSelectionLoading, setIsSelectionLoading] = useState(false);

  useEffect(() => {
    const fetchSelections = async () => {
      setIsSelectionLoading(true);
      try {
        const response = await axios.get(Constants.listSelection);
        if (response.data.status === 1) {
          setSelections(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching selections:', error);
      } finally {
        setIsSelectionLoading(false);
      }
    };
    fetchSelections();
  }, []);

  const selectionOptions = selections.map((selection) => ({
    value: selection.id,
    label: selection.name,
    ImageUrl: `${Constants.imageBaseURL}/${selection.image}`,
  }));

  const formatOptionLabel = ({ label, ImageUrl }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={ImageUrl}
        alt={`${label} flag`}
        style={{ width: 20, height: 15, marginRight: 10 }}
      />
      {label}
    </div>
  );

  const handleSelectionChange = (selectedOption) => {
    setMainSelection(selectedOption?.value || ''); // Update the parent state with the selected value
  };

  return (
    <Select
      options={selectionOptions}
      onChange={handleSelectionChange}
      formatOptionLabel={formatOptionLabel}
      placeholder="Main Selection"
      isSearchable
      isLoading={isSelectionLoading}
    />
  );
}
